import { logTermsAcceptance } from '@ibk/shared-utils';
function isPlainObject(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
function isPlatformTerm(value) {
    if (!isPlainObject(value)) {
        return false;
    }
    return (typeof value.termId === 'string' &&
        typeof value.termName === 'string' &&
        typeof value.termVersionId === 'string' &&
        typeof value.termVersionName === 'string' &&
        typeof value.sourceType === 'string' &&
        typeof value.sourceValue === 'string' &&
        (value.startAt === undefined || typeof value.startAt === 'string'));
}
function coerceTermString(value) {
    if (value == null) {
        return '';
    }
    if (typeof value === 'string') {
        return value;
    }
    if (typeof value === 'number' && !Number.isNaN(value)) {
        return String(value);
    }
    if (typeof value === 'boolean') {
        return value ? 'true' : 'false';
    }
    return '';
}
function normalizePlatformTerm(raw) {
    if (!isPlainObject(raw)) {
        return undefined;
    }
    const t = raw;
    const termId = coerceTermString(t.termId).trim();
    const termVersionId = coerceTermString(t.termVersionId).trim();
    if (!termId || !termVersionId) {
        return undefined;
    }
    if (isPlatformTerm(raw)) {
        return raw;
    }
    return {
        termId,
        termName: coerceTermString(t.termName).trim() || 'Termos',
        termVersionId,
        termVersionName: coerceTermString(t.termVersionName),
        sourceType: coerceTermString(t.sourceType).trim() || 'HTML',
        sourceValue: coerceTermString(t.sourceValue),
        ...(typeof t.startAt === 'string' ? { startAt: t.startAt } : {}),
    };
}
function unwrapDataEnvelope(response) {
    let current = response;
    for (let depth = 0; depth < 6; depth += 1) {
        if (!isPlainObject(current)) {
            break;
        }
        if ('data' in current && isPlainObject(current.data)) {
            current = current.data;
            continue;
        }
        break;
    }
    return current;
}
function failOpen(reason) {
    logTermsAcceptance('parse.status_response_fallback', { reason }, 'warn');
    return { accepted: true };
}
function parseBooleanString(value) {
    if (typeof value !== 'string') {
        return undefined;
    }
    const normalized = value.trim().toLowerCase();
    if (normalized === 'true') {
        return true;
    }
    if (normalized === 'false') {
        return false;
    }
    return undefined;
}
function coerceAcceptedDirect(value) {
    if (typeof value === 'boolean') {
        return value;
    }
    return parseBooleanString(value);
}
function coerceAcceptedFromPendingField(value) {
    if (typeof value === 'boolean') {
        return !value;
    }
    const parsed = parseBooleanString(value);
    return parsed === undefined ? undefined : !parsed;
}
function coerceAcceptedFromHasPendingTermsNumber(value) {
    if (typeof value !== 'number' || Number.isNaN(value)) {
        return undefined;
    }
    return value === 0;
}
function resolveAcceptedFromResult(result) {
    const fromAccepted = coerceAcceptedDirect(result.accepted);
    if (fromAccepted !== undefined) {
        return fromAccepted;
    }
    const fromPending = coerceAcceptedFromPendingField(result.pending);
    if (fromPending !== undefined) {
        return fromPending;
    }
    const fromHasPendingFlag = coerceAcceptedFromPendingField(result.hasPendingTerms);
    if (fromHasPendingFlag !== undefined) {
        return fromHasPendingFlag;
    }
    return coerceAcceptedFromHasPendingTermsNumber(result.hasPendingTerms);
}
export function parseTermsAcceptStatusResponse(response) {
    const root = unwrapDataEnvelope(response);
    if (!isPlainObject(root)) {
        return failOpen('invalid_envelope');
    }
    let result = null;
    if ('result' in root) {
        if (isPlainObject(root.result)) {
            result = root.result;
        }
        else {
            return failOpen('invalid_result');
        }
    }
    else if ('accepted' in root ||
        'pending' in root ||
        'hasPendingTerms' in root ||
        'termsHtml' in root ||
        'term' in root) {
        result = root;
    }
    if (result === null) {
        return failOpen('invalid_envelope');
    }
    const accepted = resolveAcceptedFromResult(result);
    if (accepted === undefined) {
        return failOpen('invalid_result');
    }
    const term = normalizePlatformTerm(result.term);
    return {
        accepted,
        ...(typeof result.termsHtml === 'string' ? { termsHtml: result.termsHtml } : {}),
        ...(term != null ? { term } : {}),
    };
}
